import type { IMarket } from "~/types/event";
import type { Platform } from "~/types/platform";

import { getMarketGroupId } from "./buildMarketGroups";
import { isWholeGroupSelected } from "./isWholeGroupSelected";

export interface IMarketChipItem {
  key: string;
  title: string;
  platform?: Platform;
  isWholeMarket: boolean;
  marketIds: string[];
}

export const buildMarketChips = (
  markets: IMarket[],
  selections: string[]
): IMarketChipItem[] => {
  const seenGroupIds = new Set<string>();

  return markets
    .filter(({ id }) => selections.includes(id))
    .flatMap<IMarketChipItem>((market) => {
      const groupId = getMarketGroupId(market);
      const groupMates = markets.filter(
        (item) => getMarketGroupId(item) === groupId
      );
      const isWholeMarket =
        groupMates.length > 1 && isWholeGroupSelected(groupMates, selections);

      if (!isWholeMarket) {
        return [
          {
            key: market.id,
            title: market.title || "",
            platform: market.platform,
            isWholeMarket: false,
            marketIds: [market.id],
          },
        ];
      }

      if (seenGroupIds.has(groupId)) {
        return [];
      }

      seenGroupIds.add(groupId);

      return [
        {
          key: groupId,
          title: market.title || "",
          isWholeMarket: true,
          marketIds: groupMates.map(({ id }) => id),
        },
      ];
    });
};
